/* * @Author: yezs * @Date: 2022-04-20 14:12:52 * @Last Modified by: yezs * @Last Modified time: 2022-04-20 15:52:38 */
<template>
  <div class="container">
    <div class="details-top">
      <div>
        <img :src="require('@/assets/imgs/floor.png').default" alt="" />
        <span>{{ shiftDetails.FloorNames }}</span>
      </div>
      <div>
        <img :src="require('@/assets/imgs/date.png').default" alt="" />
        <span>{{ shiftDetails.CDate | dateFormat('yyyy-mm-dd') }}</span>
      </div>
    </div>
    <div class="details-content">
      <!-- 早班 -->
      <div class="midday" v-for="(item, index) in time" :key="index">
        <div class="midday-title">
          <div class="midday-left">
            <img :src="item.img" alt="" />
            <span>{{ item.name }}</span>
            <p>录入人:{{ item.data.CUser || '' }}</p>
          </div>
          <!-- <span class="midday-right"
            >总人数:{{ shiftDetails.data.ElderlyTotal }}</span
          > -->
        </div>
        <div class="midday-num" v-if="$store.state.floorShiftValue === 1 && type">
          <div class="num-item" v-if="item.data.ElderlyTotal">
            <span>应住人数 </span>
            <p>{{ item.data.ElderlyTotal }}</p>
          </div>
          <div class="num-item" v-if="item.data.Actual">
            <span>实际人数</span>
            <p>{{ item.data.Actual }}</p>
          </div>
          <div class="num-item" v-if="item.data.NewAdmission">
            <span>新入住 </span>
            <p>{{ item.data.NewAdmission }}</p>
          </div>
          <div class="num-item" v-if="item.data.GoOut">
            <span>外出 </span>
            <p>{{ item.data.GoOut }}</p>
          </div>
          <div class="num-item" v-if="item.data.Discharged">
            <span>离院 </span>
            <p>{{ item.data.Discharged }}</p>
          </div>
          <div class="num-item" v-if="item.data.Carelevel0">
            <span>照护0级 </span>
            <p>{{ item.data.Carelevel0 }}</p>
          </div>
          <div class="num-item" v-if="item.data.Carelevel1">
            <span>照护1级 </span>
            <p>{{ item.data.Carelevel1 }}</p>
          </div>
          <div class="num-item" v-if="item.data.Carelevel2">
            <span>照护2级 </span>
            <p>{{ item.data.Carelevel2 }}</p>
          </div>
          <div class="num-item" v-if="item.data.Carelevel3">
            <span>照护3级 </span>
            <p>{{ item.data.Carelevel3 }}</p>
          </div>
          <div class="num-item" v-if="item.data.Carelevel4">
            <span>照护4级 </span>
            <p>{{ item.data.Carelevel4 }}</p>
          </div>
          <div class="num-item" v-if="item.data.ExclusiveCare">
            <span>专护 </span>
            <p>{{ item.data.ExclusiveCare }}</p>
          </div>
        </div>

        <div class="midday-num" v-else-if="$store.state.floorShiftValue === 2 && type">
          <div class="num-item" v-if="item.data.NewAdmission">
            <span>新入住 </span>
            <p>{{ item.data.NewAdmission }}</p>
          </div>
          <div class="num-item" v-if="item.data.Discharged">
            <span>退住 </span>
            <p>{{ item.data.Discharged }}</p>
          </div>
          <div class="num-item" v-if="item.data.Die">
            <span>离世 </span>
            <p>{{ item.data.Die }}</p>
          </div>
          <div class="num-item" v-if="item.data.ElderlyTotal">
            <span>总人数 </span>
            <p>{{ item.data.ElderlyTotal }}</p>
          </div>
          <div class="num-item" v-if="item.data.Tdischarge">
            <span>暂离院 </span>
            <p>{{ item.data.Tdischarge }}</p>
          </div>
          <div class="num-item" v-if="item.data.Aleave">
            <span>请假 </span>
            <p>{{ item.data.Aleave }}</p>
          </div>
          <div class="num-item" v-if="item.data.Tleave">
            <span>当日请假 </span>
            <p>{{ item.data.Tleave }}</p>
          </div>
          <div class="num-item" v-if="item.data.Gdoctor">
            <span>就医 </span>
            <p>{{ item.data.Gdoctor }}</p>
          </div>
          <div class="num-item" v-if="item.data.TGdoctor">
            <span>当日就医 </span>
            <p>{{ item.data.TGdoctor }}</p>
          </div>
          <div class="num-item" v-if="item.data.Actual">
            <span>当日人数 </span>
            <p>{{ item.data.Actual }}</p>
          </div>
          <div class="num-item" v-if="item.data.Returnees">
            <span>返院人数 </span>
            <p>{{ item.data.Returnees }}</p>
          </div>
          <div class="num-item" v-if="item.data.LReturns">
            <span>请假返院 </span>
            <p>{{ item.data.LReturns }}</p>
          </div>
          <div class="num-item" v-if="item.data.GdoctorReturns">
            <span>就医返院 </span>
            <p>{{ item.data.GdoctorReturns }}</p>
          </div>
          <div class="num-item" v-if="item.data.Pdrugs">
            <span>精神类药 </span>
            <p>{{ item.data.Pdrugs }}</p>
          </div>
          <div class="num-item" v-if="item.data.Adrugs">
            <span>抗凝类药 </span>
            <p>{{ item.data.Adrugs }}</p>
          </div>
          <div class="num-item" v-if="item.data.ACatheter">
            <span>留置尿管 </span>
            <p>{{ item.data.ACatheter }}</p>
          </div>
          <div class="num-item" v-if="item.data.Nftube">
            <span>鼻饲管 </span>
            <p>{{ item.data.Nftube }}</p>
          </div>
          <div class="num-item" v-if="item.data.OxygenUp">
            <span>吸氧 </span>
            <p>{{ item.data.OxygenUp }}</p>
          </div>
          <div class="num-item" v-if="item.data.CriticalIllness">
            <span>急危重症 </span>
            <p>{{ item.data.CriticalIllness }}</p>
          </div>
        </div>

        <div class="midday-num" v-else>
          <div class="num-item" v-if="item.data.NewAdmission">
            <span>新入住 </span>
            <p>{{ item.data.NewAdmission }}</p>
          </div>
          <div class="num-item" v-if="item.data.Withdraw">
            <span>退住 </span>
            <p>{{ item.data.Withdraw }}</p>
          </div>
          <div class="num-item" v-if="item.data.GoOut">
            <span>外出 </span>
            <p>{{ item.data.GoOut }}</p>
          </div>
          <div class="num-item" v-if="item.data.Die">
            <span>离世 </span>
            <p>{{ item.data.Die }}</p>
          </div>
          <div class="num-item" v-if="item.data.QuarantinePeople">
            <span>隔离人数 </span>
            <p>{{ item.data.QuarantinePeople }}</p>
          </div>
          <div class="num-item" v-if="item.data.Hospitalized">
            <span>住院 </span>
            <p>{{ item.data.Hospitalized }}</p>
          </div>
          <div class="num-item" v-if="item.data.Departure">
            <span>120送院 </span>
            <p>{{ item.data.Departure }}</p>
          </div>
          <div class="num-item" v-if="item.data.Actual">
            <span>实际人数 </span>
            <p>{{ item.data.Actual }}</p>
          </div>
        </div>
        <div class="details-digest">
          <div class="digest-item" v-for="(item, index) in item.data.ShiftModels" :key="index">
            <div class="digest-top">
              <div>
                <span>房号：</span>
                <p>{{ item.RoomNo }}</p>
              </div>
              <div>
                <span>姓名：</span>
                <p>{{ item.PName }}</p>
              </div>
            </div>
            <div class="digest-bottom">
              <span>病情摘要：</span>
              <p>{{ item.Note }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import night from '@/assets/imgs/night.png'
import middle from '@/assets/imgs/middle.png'
import morning from '@/assets/imgs/morning.png'
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      type: 0,
      time: [
        {
          key: 'Morning',
          name: '早班',
          img: morning,
          data: {}
        },
        {
          key: 'Middle',
          name: '中班',
          img: middle,
          data: {}
        },

        {
          key: 'Night',
          name: '晚班',
          img: night,
          data: {}
        }
      ],
      shiftDetails: { data: {} }
    }
  },
  // 计算属性
  computed: {},
  filters: {
    dateFormat: function (dateStr, pattern = '') {
      var dt = new Date(dateStr)
      var yy = dt.getFullYear()
      var mm = dt.getMonth() + 1 < 10 ? '0' + (dt.getMonth() + 1) : dt.getMonth() + 1
      var dd = dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate()
      var h = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours()
      var m = dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes()
      var s = dt.getSeconds() < 10 ? '0' + dt.getSeconds() : dt.getSeconds()
      if (pattern.toLowerCase() === 'yyyy-mm-dd') {
        return yy + '-' + mm + '-' + dd
      } else {
        return yy + '-' + mm + '-' + dd + ' ' + h + ':' + m
      }
    }
  },
  // 组件方法
  methods: {},

  created() {
    this.type = this.$route.query.type
    console.log('  this.type: ', this.type)
    const detail = JSON.parse(localStorage.getItem('item'))
    this.time = this.time.filter((val) => {
      val.data = detail[val.key]
      return detail[val.key].ElderlyTotal
    })
    this.shiftDetails = detail
  }
}
</script>

<style scoped>
.details-top {
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding: 12px 23px;
  display: flex;
  flex-direction: column;
}
.details-top div {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}
.details-top div:last-child {
  margin-bottom: 0;
}
.details-top div img {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}
.details-top div span {
  font-size: 16px;
  color: #029fd1;
  font-weight: bold;
}
.details-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 12px 15px;
  box-sizing: border-box;
}
.midday {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 12px;
  box-sizing: border-box;
  padding: 12px;
}
.midday-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.midday-left {
  display: flex;
  align-items: center;
}
.midday-left img {
  width: 24px;
  height: 24px;
}
.midday-left span {
  font-size: 14px;
  color: #0a0e10;
  font-weight: bold;
  margin-left: 13px;
}
.midday-left p {
  color: #7c7e80;
  font-size: 12px;
  margin: 0;
  margin-left: 20px;
}
.midday-right {
  font-size: 14px;
  color: #029fd1;
  font-weight: bold;
}
.midday-num {
  background-color: #f7f8fa;
  border-radius: 6px;
  display: flex;
  flex-wrap: wrap;
}
.num-item {
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
  position: relative;
}
.num-item::after {
  position: absolute;
  content: '';
  width: 1px;
  height: 30px;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 0;
  background-color: #ebebeb;
}
.num-item:nth-child(4n) ::after {
  content: '';
  width: 0;
  height: 0;
}
.num-item span {
  font-size: 12px;
  color: #434649;
  margin-bottom: 6px;
}
.num-item p {
  margin: 0;
  font-size: 18px;
  color: #0a0e10;
  font-weight: bold;
}
.details-digest {
  display: flex;
  width: 100%;
  flex-direction: column;
}
.digest-item {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 12px 10px;
  border-bottom: 1px solid #ebebeb;
}
.digest-item:last-child {
  border-bottom: 0;
}
.digest-top {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.digest-top div {
  flex: 1;
  display: flex;
  align-items: center;
}
.digest-top span {
  font-size: 14px;
  color: #7c7e80;
}
.digest-item p {
  flex: 1;
  font-size: 14px;
  margin: 0;
  color: #0a0e10;
}
.digest-bottom {
  display: flex;
}
.digest-bottom span {
  font-size: 14px;
  color: #029fd1;
}
</style>



// WEBPACK FOOTER //
// src/components/shiftExchange/shiftExchangeDetails.vue